import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Response } from '../interfaces/response.interface';
import { Scopes } from '../models/scope.model';
import { map } from 'rxjs/operators';
import { ApiUrlService } from './api-url.service';

@Injectable({
  providedIn: 'root',
})
export class ScopesService {
  private _url = `${this._apiService.apiUrl}/access/scopes`;

  constructor(
    private _http: HttpClient,
    private _apiService: ApiUrlService,
  ) {}

  public getScopes(): Observable<Scopes> {
    return this._http.get<Response<Scopes>>(this._url)
      .pipe(
        map(response => response.data),
        map(scopes =>
          <Scopes>Object.keys(scopes)
            .reduce((target, key) => {
              return {
                ...target,
                [key]: scopes[key].sort().filter(action => action !== '*'),
              };
            }, {}),
        ),
      );
  }
}
